import { createContext, useReducer } from 'react';
import AppReducer from './AppReducer';

const initialState = {
	step: 'select',
	shipment: '',
	upload: null,
	emails: [],
	address: [],
	notify: null,
	isLoading: false,
	isOverlayVisible: false,
	isConfirmedCloseVisible: false,
	isSaved: false,
	selectedDistributionMethod: '',
};

export const GlobalContext = createContext( initialState );
export const GlobalProvider = ( { children } ) => {
	const [ state, dispatch ] = useReducer( AppReducer, initialState );

	const notify = ( msg, className = 'error' ) => {
		if ( msg ) {
			dispatch( {
				type: 'SET_NOTIFY',
				payload: {
					class: className,
					msg,
				},
			} );
		} else {
			dispatch( {
				type: 'SET_NOTIFY',
				payload: null,
			} );
		}
	};

	return (
		<GlobalContext.Provider value={ [ state, dispatch, notify ] }>
			{ children }
		</GlobalContext.Provider>
	);
};
